import { EDividerColor as EVariant } from "./divider.types"

const colorsMap: { [V in EVariant]: string } = {
    [EVariant.White]: "bg-white",
    [EVariant.DarkBlue]: "bg-accent",
    [EVariant.SemiDarkBlue]: "bg-blue-200",
    [EVariant.MediumBlue]: "bg-blue-400",
    [EVariant.LightBlue]: "bg-blue-500"
}

const config = { colorsMap }

export { config as dividerConfig }
